import type { FeaturedCard, RecentFile, NavSection, QuickAccessItem } from '@/types'

export const featuredCards: FeaturedCard[] = [
  {
    id: '1',
    name: 'PROJECT_OVERVIEW_BID_SUBMISSION_NOTICE',
    fileType: 'pdf',
    description: 'You frequently open this',
    timestamp: '3h ago',
    hasPreview: true,
    previewImage: 'https://www.projectmanager.com/wp-content/uploads/2024/10/bid-proposal-template-screenshot-600x520.png',
  },
  {
    id: '2',
    name: 'JOT-ZFM_COMPANY_DETAILS_VAT_ADDRESS',
    fileType: 'powerpoint',
    description: 'You recently opened',
    timestamp: 'Yesterday',
    hasPreview: true,
    previewImage: 'https://www.slidegeeks.com/media/catalog/product/cache/1280x720/L/i/List_Of_Client_Reference_With_Company_Details_Ppt_PowerPoint_Presentation_Diagram_Lists_PDF_Slide_1.jpg',
  },
  {
    id: '3',
    name: 'RQF-SPECIFICATION-LIST-QUANTITY-DRAFT',
    fileType: 'excel',
    description: 'You recently opened',
    timestamp: 'Apr 25',
    hasPreview: true,
    previewImage: 'https://cdn.builder.io/api/v1/image/assets%2F26526820fa2e4f76a1441d17477482c8%2F2c3ea373a6834f2caf1c72456bf750e7?format=webp&width=800&height=1200',
  },
]

export const recentFiles: RecentFile[] = [
  {
    id: '1',
    name: 'Planner_Task_Log_Template',
    location: 'My Files',
    fileType: 'excel',
    opened: '3h ago',
    owner: 'Tony Hodson',
  },
  {
    id: '2',
    name: 'EPS PLANNING BOARD',
    location: 'Empirical Packaging Solutions',
    fileType: 'excel',
    opened: 'Yesterday at 2:11 PM',
    owner: 'Tony Hodson',
  },
  {
    id: '3',
    name: 'EPS Data Sheet Salad Tamp 1 (1)',
    location: 'Empirical Packaging Solutions',
    fileType: 'powerpoint',
    opened: 'Mon at 8:44 PM',
    owner: 'Tony Hodson',
  },
  {
    id: '4',
    name: 'Phase 2 Equipement list Ver 3',
    location: 'Empirical Packaging Solutions',
    fileType: 'excel',
    opened: 'Fri at 12:24 PM',
    owner: 'Tony Hodson',
  },
  {
    id: '5',
    name: 'Phase 2 Equipement list Ver 2',
    location: 'Empirical Packaging Solutions',
    fileType: 'excel',
    opened: 'Fri at 12:23 PM',
    owner: 'Tony Hodson',
  },
]

export const navSections: NavSection[] = [
  {
    title: 'Tony Hodson',
    items: [
      { id: 'home', label: 'Home', icon: 'Home', active: true },
      { id: 'myfiles', label: 'My files', icon: 'Folder' },
      { id: 'shared', label: 'Shared', icon: 'Users' },
      { id: 'favorites', label: 'Favorites', icon: 'Star' },
      { id: 'recycle', label: 'Recycle bin', icon: 'Trash2' },
    ],
  },
  {
    title: 'Browse files by',
    items: [
      { id: 'people', label: 'People', icon: 'User' },
      { id: 'meetings', label: 'Meetings', icon: 'Calendar' },
      { id: 'media', label: 'Media', icon: 'Image' },
    ],
  },
]

export const quickAccessItems: QuickAccessItem[] = [
  {
    id: '1',
    label: 'Empirical Packaging Soluti...',
    color: '#107c41',
    initial: 'E',
  },
]
